import { InsightPanel } from '@/components/reporting/InsightPanel';
export default function LeadAgeAnalysis(props) { return <InsightPanel type="age" {...props}/>; }